/**
 * Checks if an action is pending. In case action is an array of actionTypes
 * then checks if any of the actions is pending.
 * @param {Immutable.Set.<string>} currentlyPending - Action types which are currently pending.
 * @param {(string|Array)} action - Action type which is checked to see if it's pending.
 * @returns {bool} - Whether checked action is pending or not
 */
export default function isPending(currentlyPending, action) {
  if (!action || action === []) return false;
  return currentlyPending.some(function (item) {
    return [].concat(action).indexOf(item) !== -1;
  });
}